import Link from "next/link";

const FooterDesktop = ({data}) => {
    
    return(
        <div className='w-[full] h-[300px] pt-[60px] justify-center items-center  grid grid-cols-12 grid-rows-4'>
            <div className='row-span-3 justify-center col-span-12 gap-5 xl:px-[16%] px-[9%] w-[full]'>
                <div className='  gap-10 grid grid-cols-12 justify-around self-center'>
                    {data.map((item,index)=>(
                        <div key={index} className='flex flex-col col-span-3 gap-[16px]'>
                            <div className='font-semibold text-[18px]'>{item.title}</div>
                            {item.items.map((data,key)=>
                            <div key={key}>
                                {data.link? (<Link  href={data.link} className='text-[16px]'>{data.text}</Link>) : (<div className='text-[16px] ' dangerouslySetInnerHTML={{__html:data.text}}></div>)}
                            </div>
                            )}
                        </div>
                    ))}
                </div>
              
            </div>
        </div>
    )
}

export default FooterDesktop;